(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["refund-form"] && !Shopify.designMode) return;
  try {
    
  var ISSUE_CONFIG = {
    order_status: {
      label: 'Order Status',
      instructions: 'Please provide your order number below.',
      showOrder: true,
      showShipping: false,
      showImage: false,
      imageRequired: false
    },
    shipping_address: {
      label: 'Change Shipping Address',
      instructions: 'Please provide your order number and the correct shipping address.',
      showOrder: true,
      showShipping: true,
      showImage: false,
      imageRequired: false
    },
    packaging_mistake: {
      label: 'Packing Mistake',
      instructions: 'Please send a photo of your WHOLE packing slip and a photo of everything you received.',
      showOrder: false,
      showShipping: false,
      showImage: true,
      imageRequired: true
    },
    damaged: {
      label: 'Damage',
      instructions: 'Please provide your order number and photo(s) of the damage.',
      showOrder: true,
      showShipping: false,
      showImage: true,
      imageRequired: true
    },
    defective: {
      label: 'Defective',
      instructions: 'Please provide a photo of the lot number stamped above the label and a photo of your packing slip.',
      showOrder: false,
      showShipping: false,
      showImage: true,
      imageRequired: true
    },
    other: {
      label: 'Other',
      instructions: '',
      showOrder: false,
      showShipping: false,
      showImage: true,
      imageRequired: false
    }
  };

  function updateForm(value) {
    var config = ISSUE_CONFIG[value];

    var instructions      = document.getElementById('ContactForm-instructions');
    var orderField        = document.getElementById('ContactForm-order-field');
    var shippingField     = document.getElementById('ContactForm-shipping-field');
    var imageField        = document.getElementById('ContactForm-image-field');
    var imageRequired     = document.getElementById('ContactForm-image-required-marker');
    var imageOptional     = document.getElementById('ContactForm-image-optional-label');
    var purposeInput      = document.getElementById('ContactForm-purpose');

    // Reset all dynamic fields
    instructions.style.display  = 'none';
    instructions.textContent    = '';
    orderField.style.display    = 'none';
    shippingField.style.display = 'none';
    imageField.style.display    = 'none';
    if (purposeInput) purposeInput.value = '';

    if (!config) return;

    // Set hidden purpose field
    if (purposeInput) purposeInput.value = config.label;

    // Instructions
    if (config.instructions) {
      instructions.textContent = config.instructions;
      instructions.style.display = 'block';
    }

    // Show/hide dynamic fields
    if (config.showOrder)    orderField.style.display    = 'block';
    if (config.showShipping) shippingField.style.display = 'block';

    if (config.showImage) {
      imageField.style.display = 'block';
      if (imageRequired) imageRequired.style.display = config.imageRequired ? 'inline' : 'none';
      if (imageOptional) imageOptional.style.display = config.imageRequired ? 'none' : 'inline';
    }
  }

  // Read URL params
  var params   = new URLSearchParams(window.location.search);
  var problem  = params.get('problem');
  var orderId  = params.get('order_id');
  var select   = document.getElementById('ContactForm-issue-type');

  // Auto-select from ?problem= if valid
  if (problem && ISSUE_CONFIG[problem] && select) {
    select.value = problem;
    updateForm(problem);
  }

  // Pre-fill order number from ?order_id= if present
  if (orderId) {
    var orderInput  = document.getElementById('ContactForm-order-number');
    var hiddenOrder = document.getElementById('ContactForm-order-id');
    if (orderInput)  orderInput.value  = orderId;
    if (hiddenOrder) hiddenOrder.value = orderId;
  }

  // Dropdown change handler
  if (select) {
    select.addEventListener('change', function() {
      updateForm(this.value);
    });
  }

  // Sync visible order number field → hidden contact[Order ID] field
  var orderNumberInput = document.getElementById('ContactForm-order-number');
  if (orderNumberInput) {
    orderNumberInput.addEventListener('input', function() {
      var hidden = document.getElementById('ContactForm-order-id');
      if (hidden) hidden.value = this.value;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
